/** Namespace `labFlows` — PLAT-2026-110: « Kịch bản » của phòng thử Tingee (chạy theo bộ / theo luồng). Bản gốc tiếng Việt. */
export const labFlows = {
  section: "Kịch bản",
  "flow.suite": "Bộ kiểm chỉ đọc",
  "flow.va": "Luồng chuẩn VA",
  "flow.bankLink": "Luồng Bank Link",
  "help.suite": "Chạy liền các hàm CHỈ ĐỌC — không đổi gì ở Tingee. Dùng để biết bộ thông số còn sống, quyền đủ chưa.",
  "help.va": "Đúng quy trình Tingee: tạo VA ⇒ xác nhận ⇒ đăng ký nhận biến động ⇒ chờ tiền về ⇒ đối soát. Bước sau tự chạy khi bước trước xong.",
  "help.bankLink": "Khách tự liên kết trong widget Tingee (chọn ngân hàng, đăng nhập, OTP) ⇒ chờ webhook liên kết ⇒ chờ tiền về ⇒ đối soát.",
  run: "Chạy",
  rerun: "Chạy lại",
  reset: "Làm lại từ đầu",
  start: "Bắt đầu",
  merchantId: "Merchant ID (tuỳ chọn)",
  bank: "Ngân hàng",
  loadBanks: "Nạp danh sách ngân hàng",
  accountType: "Loại tài khoản",
  "accountType.personal-account": "Cá nhân",
  "accountType.business-account": "Doanh nghiệp",
  "accountType.business-household-account": "Hộ kinh doanh",
  mode: "Cách nhận biến động",
  "mode.va": "Tài khoản ảo (VA)",
  "mode.account": "Số tài khoản gốc",
  accountNumber: "Số tài khoản",
  accountName: "Tên chủ tài khoản",
  identity: "CCCD / MST",
  mobile: "Số điện thoại nhận OTP",
  subscribeNotify: "Đăng ký nhận biến động riêng — ngân hàng như ACB đòi bước này",
  allowedBanks: "Chỉ hiện các ngân hàng (mã, phẩy ngăn cách — trống = tất cả)",
  otp: "Mã OTP",
  submitOtp: "Xác nhận OTP",
  confirmTwice: "Bấm lần nữa để GỬI THẬT",
  openLink: "Mở trang xác nhận của ngân hàng",
  reopenWidget: "Mở lại widget",
  "step.banks": "Danh sách ngân hàng",
  "step.transactions": "Giao dịch 24 giờ",
  "step.vaPaging": "Danh sách VA",
  "step.shops": "Cửa hàng",
  "step.create": "Tạo VA (create-va)",
  "step.confirm": "Xác nhận",
  "step.notify": "Đăng ký nhận biến động",
  "step.session": "Tạo phiên liên kết",
  "step.widget": "Khách liên kết trong widget",
  "step.linked": "Webhook liên kết (bank-link)",
  "step.payment": "Chờ biến động số dư",
  "step.reconcile": "Đối soát (transaction/get-paging)",
  "status.idle": "Chưa chạy",
  "status.running": "Đang chạy…",
  "status.waiting": "Đang chờ…",
  "status.ok": "Đạt",
  "status.failed": "Hỏng",
  "status.skipped": "Bỏ qua",
  needMerchant: "Cần Merchant ID",
  waitOtp: "Nhập OTP ngân hàng gửi.",
  waitLink: "Mở trang ngân hàng, đăng nhập và đồng ý — chờ Tingee báo bằng webhook trạng thái VA.",
  notNeeded: "Ngân hàng này không cần bước riêng.",
  waitPayment: "Chuyển thử vài nghìn đồng vào {number}. Tiền về sẽ hiện ở đây (webhook đã kiểm chữ ký).",
  paymentCount: "{n} khoản tiền về",
  vaNotOwn: "Chuyển vào SỐ VA ở trên — chuyển vào STK gốc {own} sẽ KHÔNG có thông báo (liên kết đang ở chế độ VA).",
  alphaVaNote: "Số có chữ ở trên là VA của VPBank (gắn STK gốc {own}) — chuyển vào VA này. Khoản chuyển thẳng vào STK gốc có được báo hay không: chưa đo.",
  reconcileNow: "Đối soát ngay",
  reconcileResult: "Webhook {w} · Đối soát {p} · Khớp {m} · Chỉ webhook {wo} · Webhook lỡ {po}",
  vaReady: "VA {va} · {bank}",
  needPublicWebhook: "Webhook hiện là địa chỉ nội bộ — Tingee không gọi tới được. Mở tunnel và đặt HQ_PUBLIC_API_URL.",
  needBank: "Chọn ngân hàng trước.",
  vaPrefix: "Tiền tố VA (BIDV / VietinBank DN)",
  vaSuffix: "Hậu tố VA (BIDV / VietinBank / OCB DN)",
  merchantName: "Tên điểm bán (bắt đầu bằng tên DN đăng ký)",
  taxCode: "Mã số thuế",
  merchantAddress: "Địa chỉ DN",
  acbUserId: "ACB User ID (ACB HKD / DN)",
  "confirm.otp": "Xác nhận: OTP ngân hàng gửi.",
  "confirm.deep_link": "Xác nhận: khách duyệt trong app ngân hàng (VCB Digibank) — kết quả về bằng webhook.",
  "confirm.authorize_link": "Xác nhận: đăng nhập TPBank BIZ để duyệt — kết quả về bằng webhook.",
  ruleMissing: "Còn thiếu: {fields}",
  "setup.api": "Cần cấu hình tài khoản doanh nghiệp qua API TRƯỚC (/docs/cau-hinh-tai-khoan-dn) — chưa làm Tingee sẽ từ chối.",
  "setup.tingee": "Cần nhờ Tingee cấu hình tài khoản doanh nghiệp TRƯỚC.",
  "setup.ibusiness": "Khách phải bật « nhận loa » trong VIB iBusiness TRƯỚC.",
  metadataEchoed: "Tingee trả lại metadata ✓",
  metadataMissing: "Tingee KHÔNG trả lại metadata ✗",
  durationMs: "{ms} ms",
} as const;
